// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__BjszW","progressBar":"styles_progressBar__0+HHT"};